import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueCookie from 'vue-cookie'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import 'element-ui/lib/theme-chalk/index.css'
import '@/style/common.scss'
import httpRequest from './utils/httpRequest'
import SlideVerify from 'vue-monoplasty-slide-verify' // 拼图验证码
import '@/assets/icon/iconfont.css'
import { VueJsonp } from 'vue-jsonp'
Vue.use(SlideVerify)

Vue.use(VueCookie)
Vue.use(VueJsonp)
Vue.config.productionTip = false
Vue.use(ElementUI,{ locale })

// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法

Vue.prototype.$routerWin = process.env.NODE_ENV === 'development' ? false : true; // 路由跳转新窗口
console.log(process.env.NODE_ENV);
// new Vue({
//   router,
//   store,
//   render: h => h(App),
// }).$mount('#app');
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

